/**
 *  ScanlinesFilter
 *
 *  Created by Legman on 09/11/2016.
 *
 */

const frag = "precision highp float;\n#define GLSLIFY 1\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nuniform float time;\n\nvoid main() {\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float a = color.a;\n    color -= abs(sin(vFilterCoord.y * 1000.0 + time * 2.5)) * -0.6;\n    color.a = a;\n    gl_FragColor = color;\n}";

/**
 * @class
 */
export default class ScanlinesFilter extends PIXI.Filter {
    /**
     * @param {PIXI.Sprite} [sprite]
     * @constructor
     */
    constructor(sprite) {
        const maskMatrix = new PIXI.Matrix();

        super(null, frag);

        this.maskSprite = sprite;
        this.maskMatrix = maskMatrix;

        this.uniforms.time = 0;
        this.uniforms.filterMatrix = maskMatrix;
    }

    apply(filterManager, input, output) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        filterManager.applyFilter(this, input, output);
    }

    /**
     * @returns {number}
     */
    get time() {
        return this.uniforms.time;
    }

    /**
     * @param {number} value
     */
    set time(value) {
        this.uniforms.time = value;
    }
}
